


























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// components
import FolderTree from "@/components/common/folders/FolderTree.vue";
import vSelect from "vue-select";
// service methods
import { getAllTemplates } from "@/services/templates/templateService";
import { getFilteredSolutions } from "@/services/solutions/solutionService";
// types
import { Folder, FolderEntites } from "@/services/folders/types";
import { Option } from "@/services/common/types";
import { Solution, SolutionsFilterDtoIn } from "@/services/solutions/types";
import { bus } from "@/bus";
import { selectSolutionFields } from "@/components/solutions/fields/selectSolutionFields";

@Component({
    components: {
        vSelect,
        FolderTree
    }
})
export default class SelectSolutionModal extends Vue {
    // custom filter
    @Prop() powerPlanFilter!: boolean

    // local state
    solutions = [] as Array<Solution>;
    fields = selectSolutionFields;
    isBusy = false;
    solutionTypes = [] as Array<string>;

    // folders
    folderEntity = FolderEntites.Solutions;
    selectedFolderNode = {} as Folder;
    showFolderTree = true;

    // filter
    selectedTemplate = null as Option | any;
    selectedSolutionFilter = null as Option | any;
    filterWidth = "" as string;
    filterHeight = "" as string;

    // filter options
    templates = [] as Array<Option>;
    searchText = "" as string;
    solutionsFilter = [
        { id: "true", text: "Solutions with Power Plan" },
        { id: "false", text: "Solutions without Power Plan" }
    ];

    selectedSolutions = [] as Solution[];
    showSolutionsWithoutPlayerOnly = false;
    multiPicker = false;

    // watchers
    @Watch("filterActive")
    onFilterChanged(value: any, oldValue: any) {
        this.showFolderTree = !value;
    }

    // computed
    get model(): Array<Solution> {
        if (this.filterActive) {
            return this.solutions.filter(
                x => (this.searchText === "" ? true : x.name.toLowerCase().includes(this.searchText.toLowerCase())) &&
                    (this.filterWidth === "" ? true : x.width === +this.filterWidth) &&
                    (this.filterHeight === "" ? true : x.height === +this.filterHeight)
            );
        } else {
            if (this.showFolderTree) {
            // If the folder tree is visible, return only solutions in the selected folder
                return this.solutions.filter(
                    x => this.selectedFolderNode.id ? x.folderId === this.selectedFolderNode.id : true
                );
            } else {
            // If the folder tree is hidden, return all solutions
                return this.solutions;
            }
        }
    }

    get title() {
        return this.showSolutionsWithoutPlayerOnly
            ? this.$i18n.t("player.selectSolution") : this.$i18n.t("solution.selectSolutions");
    }

    get filterActive(): boolean {
        return (
            (this.selectedTemplate && Object.keys(this.selectedTemplate.id).length > 0) ||
            (this.selectedSolutionFilter && Object.keys(this.selectedSolutionFilter.id).length > 0) ||
            this.searchText !== "" ||
            this.filterWidth !== "" ||
            this.filterHeight !== "");
    }

    open(solutionTypes: [], showSolutionsWithoutPlayer = false, multiPicker = false) {
        this.multiPicker = multiPicker;
        this.solutionTypes = solutionTypes;
        this.showSolutionsWithoutPlayerOnly = showSolutionsWithoutPlayer;
        this.fetchData();
        this.$bvModal.show("modal-selectSolution");
    }

    save() {
        this.$bvModal.hide("modal-selectSolution");
        this.$emit("select", this.selectedSolutions);
    }

    rowSelected(items: Solution[]) {
        this.selectedSolutions = items;
    }

    setSelectedFolder(folder: Folder) {
        this.selectedFolderNode = folder;
    }

    toggleFolderTree() {
        if (!this.filterActive) {
            this.showFolderTree = !this.showFolderTree;
        }
    }

    fetchData() {
        this.isBusy = true;
        this.loadSolutions();
        getAllTemplates().then(response => {
            this.templates = response.map(x => ({
                id: x.id,
                text: x.name
            }));
        });
    }

    loadSolutions() {
        getFilteredSolutions({
            templateId: this.selectedTemplate ? this.selectedTemplate.id : "",
            solutionTypes: this.solutionTypes ? this.solutionTypes : []
        } as SolutionsFilterDtoIn).then(response => {
            if (this.showSolutionsWithoutPlayerOnly) {
                response = response.filter(x => !x.playerId);
            }
            if (this.selectedSolutionFilter) {
                if (this.selectedSolutionFilter.id === "true") {
                    response = response.filter(x => x.powerPlanId);
                } else if (this.selectedSolutionFilter.id === "false") {
                    response = response.filter(x => !x.powerPlanId);
                }
            }
            this.solutions = response;
            this.isBusy = false;
        });
    }

    loadSolutionsForPowerPlans() {
        getFilteredSolutions({
            templateId: this.selectedTemplate ? this.selectedTemplate.id : "",
            solutionTypes: this.solutionTypes ? this.solutionTypes : []
        } as SolutionsFilterDtoIn).then(response => {
            this.solutions = this.showSolutionsWithoutPlayerOnly
                ? response.filter(x => !x.playerId)
                : response;
            this.solutions = this.solutions.filter(x => !x.powerPlanId);
            this.isBusy = false;
        });
    }

    clearFilter() {
        this.selectedTemplate = null;
        this.selectedSolutionFilter = null;
        this.filterWidth = "";
        this.filterHeight = "";
        this.selectedSolutions = [] as Solution[];
        this.loadSolutions();
    }

    resetState() {
        this.selectedTemplate = null;
        this.selectedSolutionFilter = null;
        this.searchText = "";
        this.filterWidth = "";
        this.filterHeight = "";
        this.selectedSolutions = [] as Solution[];
    }
}
